<p>edit-notification-details works!</p>
